import { useState } from "react";
import type { MenuButtonColor } from "@smartsuite/react-ui/lib";
import {
  DotsMenu,
  MenuLineSeparator,
  MenuOption,
} from "@smartsuite/react-ui/lib";
import { useRootStore } from "../../stores/hooks";
import { t } from "i18next";
import { observer } from "mobx-react-lite";
import { getLocalCssColorVariables } from "../../utils/cssVariablesUtils";
import { StyledThreeDotsMenu } from "./styles";
import { Colors, SolutionColorVariables } from "@smartsuite/types";

export const AutomationThreeDotsMenu = observer<{
  onRename: () => void;
  onDelete: () => void;
  onCopyLink: () => void;
  onEditDescription: () => void;
  onDuplicate: () => void;
  backgroundsColors?: MenuButtonColor;
}>(
  ({
    onRename,
    onDelete,
    onCopyLink,
    onEditDescription,
    onDuplicate,
    backgroundsColors,
  }) => {
    const store = useRootStore();
    const { candidate, isLimitReached } = store.automations;
    const [opened, setOpened] = useState(false);
    return (
      <DotsMenu
        at={"bottom"}
        my={"top+10"}
        opened={opened}
        onToggle={setOpened}
        backgroundColors={backgroundsColors}
        portalStyles={getLocalCssColorVariables(store.theme)}
        smallListPaddings={true}
      >
        <StyledThreeDotsMenu>
          <MenuOption
            onClick={() => {
              setOpened(false);
              onCopyLink();
            }}
            iconName={"link"}
            disabled={candidate.isNew()}
          >
            {t("3dot-menu.copy-link")}
          </MenuOption>
          <MenuOption onClick={onRename} iconName={"edit-smaller"}>
            {t("3dot-menu.edit-name")}
          </MenuOption>
          <MenuOption
            onClick={() => {
              setOpened(false);
              onEditDescription();
            }}
            iconName={"edit-smaller"}
          >
            {candidate.self.description.length > 0
              ? t("3dot-menu.edit-description")
              : t("3dot-menu.add-description")}
          </MenuOption>
          <MenuOption
            onClick={() => {
              setOpened(false);
              onDuplicate();
            }}
            iconName={"layers"}
            iconColor={SolutionColorVariables.sc1}
            iconSize={"S"}
            iconSmallMargin
            disabled={candidate.isNew() || isLimitReached}
            tooltipText={
              isLimitReached
                ? t("automation-list.reached-max-automations", {
                    number: store.featureFlags.limits.maxAutomationsPerSolution,
                  })
                : undefined
            }
          >
            {t("3dot-menu.duplicate-automation")}
          </MenuOption>
          <MenuLineSeparator />
          <MenuOption
            onClick={() => {
              setOpened(false);
              onDelete();
            }}
            iconName={"trash-1"}
            iconColor={Colors.bRed}
            iconSize={"S"}
            iconSmallMargin
            disabled={candidate.isNew()}
          >
            {t("3dot-menu.delete-automation")}
          </MenuOption>
        </StyledThreeDotsMenu>
      </DotsMenu>
    );
  },
);
